import { clearAuth, getToken } from '@/utils/token'
import type { AxiosResponse, RequestOptions } from '@@/plugin-request/request'
import type { RequestConfig } from '@umijs/max'
import { history } from '@umijs/max'
import { message } from 'antd'
import type { Response } from 'types'
import { BASE_URL, PROXY_OPEN } from './../config/constant'

type BizError = Error & {
    info?: Response
}

const authErrorCodes = [401, 1003, 1004, 1005]
let isHandlingAuthError = false

function handleAuthError(messageText?: string) {
    if (isHandlingAuthError) return

    isHandlingAuthError = true
    message.error(messageText || '登录状态已失效，请重新登录')
    clearAuth()

    if (history.location.pathname !== '/user/login') {
        history.push('/user/login')
    }
}

export const errorConfig: RequestConfig<Response> = {
    responseInterceptors: [
        (response: AxiosResponse<any, any>) => {
            if (response.data && typeof response.data === 'object' && typeof response.data.code === 'number' && response.data.code !== 200) {
                response.data.success = response.data.code === 200
            }
            return response
        },
    ],
    errorConfig: {
        errorThrower: (res: Response) => {
            if (res.code !== 200) {
                const error: BizError = new Error(res.message || '请求失败')
                error.name = 'BizError'
                error.info = res
                throw error
            }
        },
        errorHandler: (error, opts) => {
            if (opts?.skipErrorHandler) throw error

            if (error.name === 'BizError') {
                const errorInfo = (error as BizError).info

                if (authErrorCodes.includes(errorInfo?.code || 0)) {
                    handleAuthError(errorInfo?.message)
                    return
                }

                message.error(errorInfo?.message || '请求失败')
                return
            }

            if ('response' in error && error.response) {
                if (error.response.status === 401) {
                    handleAuthError((error.response.data as Response | undefined)?.message)
                    return
                }

                if (error.response.data) {
                    message.error((error.response.data as Response).message || JSON.stringify(error.response.data))
                    return
                }

                message.error('Request failed')
                return
            }

            if ('request' in error && error.request) {
                message.error('None response! Please retry.')
                return
            }

            message.error('Request error, please retry.')
        },
    },
    requestInterceptors: [
        (config: RequestOptions) => {
            if (!PROXY_OPEN) {
                config.url = `${BASE_URL}${config.url}`
            }
            const token = getToken()
            const headers = {
                ...config.headers,
            }

            if (token) {
                headers.Authorization = `Bearer ${token}`
            }

            return {
                ...config,
                headers,
            }
        },
    ],
}
